module.exports = __webpack_public_path__ + "img/Weapon_01.93a718fc.png";